let mainSlider;

export default () => ({
	handle: '',
	product: null,
	current_variant: null,
	activeSlide: 1,
	activeThumb: 1,
	quantity: 1,
	variant_selections: [],
	selection_quantity: 5,
	product_composition: '',
	product_composition_sku: [],
	set_data: {},
	set_data_options_default: [],
	composition_name: '',
	composition_sku: 'Custom',
	active_composition: [],
	small_selection: [],
	large_selection: [],
	current_selection: [],
	show_popup: false,
	show_error: false,
	sticky_visible: false,
	showTax: false,

	get discount() {
		const price = this.current_variant?.price;
		const compare_price = this.current_variant?.compare_at_price;
		if (compare_price && compare_price > price) {
			const sale = Math.round(((compare_price - price) * 100) / compare_price);
			return `-${sale} %`;
		} else {
			return '';
		}
	},

	get price() {
		const price = (this.current_variant?.price / 100).toFixed(2).replace('.', ',');
		return price;
	},

	get comparePrice() {
		if (
			this.current_variant?.compare_at_price &&
			this.current_variant?.compare_at_price > this.current_variant?.price
		) {
			const comparePrice = (this.current_variant?.compare_at_price / 100)
				.toFixed(2)
				.replace('.', ',');
			return comparePrice;
		} else {
			return '';
		}
	},

	getCompositionName(name) {
		let formated_name = '';

		if (name === 'Custom') {
			if (window.Shopify.locale === 'de') {
				formated_name = 'Selber auswählen';
			} else {
				formated_name = 'Choose yourself';
			}
		} else {
			formated_name = name;
		}

		return formated_name;
	},

	formatOption(option_name) {
		if (option_name.includes(':')) {
			return option_name.split(':')[1];
		} else {
			return option_name;
		}
	},

	async getProduct() {
		const url = `${window.Shopify.routes.root}products/${this.handle}?view=get-product-json`;

		const response = await fetch(url);
		if (response.status !== 200) return;
		const product = await response.json();

		this.product = product;
		this.current_variant = this.product.selected_or_first_available_variant;
		this.selection_quantity = this.getNumberFromString(this.current_variant.title);
	},

	getSetData() {
		const data_container = document.getElementById('product-set-data');
		if (data_container) {
			this.set_data = JSON.parse(data_container.innerText);
			this.set_data_options_default = this.set_data.options;
			if (this.set_data.small_compositions.length > 0) {
				this.small_selection = this.set_data.small_compositions[1];
			} else {
				this.large_selection = this.set_data.small_compositions[0];
			}

			if (this.set_data.large_compositions.length > 0) {
				this.large_selection = this.set_data.large_compositions[1];
			} else {
				this.large_selection = this.set_data.large_compositions[0];
			}
			if (
				this.set_data.small_compositions.length > 0 &&
				this.set_data.large_compositions.length === 0
			) {
				this.active_composition = this.small_selection.options;
				this.composition_name = this.small_selection.name;
			}

			if (
				this.set_data.large_compositions.length > 0 &&
				this.set_data.small_compositions.length === 0
			) {
				this.active_composition = this.large_selection.options;
				this.composition_name = this.large_selection.name;
				if (this.large_selection.sku !== '') {
					this.composition_sku = this.large_selection.sku;
				} else {
					this.composition_sku = 'Custom';
				}
			}

			if (
				this.set_data.small_compositions.length > 0 &&
				this.set_data.large_compositions.length > 0
			) {
				this.active_composition = this.small_selection.options;
				this.composition_name = this.small_selection.name;
				if (this.small_selection.sku !== '') {
					this.composition_sku = this.small_selection.sku;
				} else {
					this.composition_sku = 'Custom';
				}
			}
		}
	},

	buildVariantSelections() {
		if (!this.product) return;
		if (this.product.variants.length > 1) {
			this.product.variants.forEach((variant) => {
				this.variant_selections.push(this.getNumberFromString(variant.title));
			});
		}
	},

	setVariant(title) {
		if (!this.current_variant) return;
		if (this.current_variant.title === title) {
			this.openPopup();
		} else {
			const variant = this.product.variants.find((el) => el.title === title);

			this.current_variant = variant;
			this.selection_quantity = this.getNumberFromString(variant.title);

			if (this.selection_quantity < 10) {
				this.active_composition = this.small_selection.options;
				this.composition_name = this.small_selection.name;
				if (this.small_selection.sku !== '') {
					this.composition_sku = this.small_selection.sku;
				} else {
					this.composition_sku = 'Custom';
				}
			} else {
				this.active_composition = this.large_selection.options;
				this.composition_name = this.large_selection.name;
				if (this.large_selection.sku !== '') {
					this.composition_sku = this.large_selection.sku;
				} else {
					this.composition_sku = 'Custom';
				}
			}
			this.setActiveMedia();
		}
	},

	setDefaultPreselectedValues() {
		if (this.variant_selections.length === 0) return;

		this.variant_selections.forEach((item) => {
			if (item < 10) {
				this.small_selection.options.forEach((value, index) => {
					const select = document.getElementById(`set${item}-option-${index}`);
					if (select) {
						select.value = value;
					}
				});
			} else {
				this.large_selection.options.forEach((value, index) => {
					const select = document.getElementById(`set${item}-option-${index}`);
					if (select) {
						select.value = value;
					}
				});
			}
		});
	},

	setComposition(name, sku) {
		this.current_selection = [];
		const formated_options = this.set_data.default_state.find((el) => el.includes('X-'));
		if (formated_options && sku === 'Custom') {
			this.set_data.options = this.set_data.formated_options;
		} else {
			this.set_data.options = this.set_data_options_default;
		}
		setTimeout(() => {
			if (this.selection_quantity < 10) {
				const selected_composition = this.set_data.small_compositions.find(
					(composition) => composition.name === name,
				);

				if (selected_composition.options.length > 0) {
					this.small_selection = selected_composition;
					this.small_selection.options.forEach((value, index) => {
						const select = document.getElementById(`set${this.selection_quantity}-option-${index}`);
						if (select) {
							select.value = value;
						}
					});

					this.active_composition = this.small_selection.options;
					this.selection_quantity = this.small_selection.options.length;
					this.composition_name = name;
					if (sku !== '') {
						this.composition_sku = sku;
					} else {
						this.composition_sku = 'Custom';
					}
					for (let i = 0; i < this.selection_quantity; i++) {
						this.current_selection.push(
							document.getElementById(`set${this.selection_quantity}-option-${i}`).value,
						);
					}
				} else {
					this.small_selection = [];
					this.active_composition = [];
					this.selection_quantity = 0;
					this.current_selection = [];
				}
			} else {
				const selected_composition = this.set_data.large_compositions.find(
					(composition) => composition.name === name,
				);

				if (selected_composition.options.length > 0) {
					this.large_selection = selected_composition;
					this.large_selection.options.forEach((value, index) => {
						const select = document.getElementById(`set${this.selection_quantity}-option-${index}`);
						if (select) {
							select.value = value;
						}
					});

					this.active_composition = this.large_selection.options;
					this.selection_quantity = this.large_selection.options.length;
					this.composition_name = name;

					if (sku !== '') {
						this.composition_sku = sku;
					} else {
						this.composition_sku = 'Custom';
					}

					for (let i = 0; i < this.selection_quantity; i++) {
						this.current_selection.push(
							document.getElementById(`set${this.selection_quantity}-option-${i}`).value,
						);
					}
				} else {
					this.large_selection = [];
					this.active_composition = [];
					this.selection_quantity = 0;
					this.current_selection = [];
				}
			}
		}, 10);
	},

	updateComposition(index) {
		const select = document.getElementById(`set${this.selection_quantity}-option-${index}`);
		this.composition_name = 'Custom';
		if (this.selection_quantity < 10) {
			this.small_selection = this.set_data.small_compositions[0];
		} else {
			this.large_selection = this.set_data.large_compositions[0];
		}
		this.current_selection[index] = select.value;
	},

	openPopup() {
		for (let i = 0; i < this.selection_quantity; i++) {
			this.current_selection.push(
				document.getElementById(`set${this.selection_quantity}-option-${i}`).value,
			);
		}
		this.show_popup = true;
		document.body.classList.add('no-scroll');
	},

	closePopup() {
		this.current_selection = [];
		this.show_popup = false;
		document.body.classList.remove('no-scroll');
	},

	applyComposition() {
		this.active_composition = this.current_selection;
		if (this.selection_quantity < 10) {
			this.small_selection.options = this.current_selection;
		} else {
			this.large_selection.options = this.current_selection;
		}

		this.show_popup = false;
		this.current_selection = [];
		document.body.classList.remove('no-scroll');
	},

	async addToCart() {
		this.product_composition = [];
		this.product_composition_sku = [];
		if (this.active_composition.length > 0 && this.current_variant) {
			let SKU = '';
			if (this.composition_name === 'Custom' || this.composition_name === '') {
				SKU = 'Custom';
			} else {
				SKU = this.composition_sku;
			}

			this.active_composition.forEach((composition) => {
				if (composition.includes(':')) {
					this.product_composition.push(composition.split(':')[1]);
					this.product_composition_sku.push(composition.split(':')[0]);
				} else {
					this.product_composition.push(composition);
					this.product_composition_sku.push(' ');
				}
			});

			const productData = {
				id: this.current_variant?.id,
				quantity: Number(this.quantity),
				properties: {
					[this.composition_name]: this.product_composition.join(),
					_compositionSKU: SKU,
					_compositionProductSKUs: this.product_composition_sku.join(),
				},
				sections: 'cart-main,header',
			};

			const response = await fetch(window.routes.cartAdd + '.js', {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: JSON.stringify(productData),
			});
			const data = await response.json();

			if (response.ok) {
				const destinationCartPopup = document.getElementById('cart-popup');
				const sourceCartPopup = new DOMParser()
					.parseFromString(data.sections['header'], 'text/html')
					.getElementById('cart-popup');

				if (destinationCartPopup && sourceCartPopup) {
					destinationCartPopup.innerHTML = sourceCartPopup.innerHTML;
				}

				this.$dispatch('cart-update');
			}
			this.gtmAddToCart();
		} else {
			this.show_error = true;
		}
	},

	async addUpsellToCart(id, config) {
		if (this.current_variant) {
			const productData = {
				id: id,
				quantity: 1,
				sections: 'cart-main,header',
			};

			const response = await fetch(window.routes.cartAdd + '.js', {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: JSON.stringify(productData),
			});

			const data = await response.json();

			if (response.ok) {
				const destinationCartPopup = document.getElementById('cart-popup');
				const sourceCartPopup = new DOMParser()
					.parseFromString(data.sections['header'], 'text/html')
					.getElementById('cart-popup');

				if (destinationCartPopup && sourceCartPopup) {
					destinationCartPopup.innerHTML = sourceCartPopup.innerHTML;
				}

				this.$dispatch('cart-update');
			}

			this.gtmUpsellAddToCart(config);
		}
	},

	setActiveMedia() {
		const active_media = this.product.media.find(
			(el) => el.alt === this.current_variant.featured_media.alt && el.alt !== null,
		);
		if (active_media) {
			const index = this.product.media.indexOf(active_media);
			this.activeSlide = index + 1;
			this.activeThumb = index + 1;
		}
	},

	createSlider() {
		mainSlider = new window.Swiper('.product-gallery__main-slider', {
			slidesPerView: 1.05,
			speed: 500,
			breakpoints: {
				1024: {
					slidesPerView: 'auto',
				},
			},
			pagination: {
				el: '.product-gallery__pagination',
				type: 'progressbar',
			},
		});

		mainSlider.on('slideChange', (e) => {
			this.activeThumb = e.activeIndex + 1;
		});
	},

	enableSticky() {
		const sticky_start = this.$refs.scrollStart.offsetTop;
		const footer = document.querySelector('.footer');
		const sticky_end = footer.offsetTop - footer.offsetHeight * 4;

		if (window.scrollY >= sticky_start && window.scrollY < sticky_end) {
			this.sticky_visible = true;
		} else {
			this.sticky_visible = false;
		}
	},

	getNumberFromString(string) {
		const formated_string = string.match(/\d+/);
		if (formated_string) {
			const nums = Number(formated_string[0]);
			if (nums) {
				return nums;
			}
		} else return '';
	},

	gtmAddToCart() {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'EEC-AddToCart',
			value: (this.current_variant.price / 100).toFixed(2),
			ecommerce: {
				currencyCode: window.Shopify.currency.active,
				add: {
					products: [
						{
							id: this.current_variant.sku,
							sku: this.current_variant.sku,
							name: this.product.title,
							price: (this.current_variant.price / 100).toFixed(2),
							brand: 'Brooklyn Soap Company',
							category: this.product.main_category,
							quantity: this.quantity,
						},
					],
				},
			},
			items: [{ id: this.current_variant.sku, google_business_vertical: 'retail' }],
		});
	},

	gtmUpsellAddToCart(config) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'EEC-AddToCart',
			value: config.price,
			ecommerce: {
				currencyCode: window.Shopify.currency.active,
				add: {
					products: [
						{
							id: config.sku,
							sku: config.sku,
							name: config.title,
							price: config.price,
							brand: 'Brooklyn Soap Company',
							category: config.category,
							quantity: 1,
						},
					],
				},
			},
			items: [{ id: config.sku, google_business_vertical: 'retail' }],
		});

		setTimeout(function () {
			// Clear the ecommerce data for subsequent hits.
			window.dataLayer.push({ ecommerce: null });
		}, 3);
	},

	gtmTracking() {
		window.dataLayer = window.dataLayer || [];
		let url = '';
		let collection_handle = '';

		if (this.product.main_category.includes('&')) {
			collection_handle = this.product.main_category
				.replace(' & ', '-')
				.toLowerCase()
				.replace(' ', '-');
		} else if (this.product.main_category.includes('Root')) {
			collection_handle = 'all';
		} else {
			collection_handle = this.product.main_category.toLowerCase().replace(' ', '-');
		}

		url = `${window.Shopify.routes.root}collections/${collection_handle}`;

		window.dataLayer.push({
			event: 'EEC-ProductDetailView',
			value: (this.current_variant.price / 100).toFixed(2),
			items: [{ id: this.current_variant.sku, google_business_vertical: 'retail' }],
			ecommerce: {
				detail: {
					actionField: { list: this.product.main_category },
					products: [
						{
							id: this.current_variant.sku,
							sku: this.current_variant.sku,
							name: this.product.title,
							price: (this.current_variant.price / 100).toFixed(2),
							brand: 'Brooklyn Soap Company',
							attribute_set_name: this.composition_name,

							category: this.product.main_category,
							category_path: url,
						},
					],
				},
			},
		});

		setTimeout(function () {
			// Clear the ecommerce data for subsequent hits.
			window.dataLayer.push({ ecommerce: null });
		}, 3);
	},

	klaviyoTracking() {
		const product_collections = this.product.collections.map((collection) => collection.title);
		const compare_at_price = this.current_variant.compare_at_price
			? (this.current_variant.compare_at_price / 100).toFixed(2)
			: null;
		let _learnq = window._learnq || [];
		let tracking_object = {
			Name: this.product.title,
			ProductID: this.product.id,
			Categories: product_collections,
			ImageURL: this.product.featured_image,
			URL: `${window.location.origin}${this.product.url}`,
			Brand: this.product.vendor,
			Price: (this.current_variant.price / 100).toFixed(2),
			CompareAtPrice: compare_at_price,
		};

		setTimeout(() => {
			_learnq.push(['track', 'Viewed Product', tracking_object]);
			_learnq.push([
				'trackViewedItem',
				{
					Title: tracking_object.Name,
					ItemId: tracking_object.ProductID,
					Categories: tracking_object.Categories,
					ImageUrl: tracking_object.ImageURL,
					Url: tracking_object.URL,
					Metadata: {
						Brand: tracking_object.Brand,
						Price: tracking_object.Price,
						CompareAtPrice: tracking_object.CompareAtPrice,
					},
				},
			]);
		}, 250);
	},

	showTaxPopup() {
		if (window.innerWidth < 1024) {
			this.showTax = true;
		}
	},

	hideTaxPopup() {
		if (window.innerWidth < 1024) {
			this.showTax = false;
		}
	},

	init() {
		this.$watch('handle', () => {
			this.getProduct();
			this.createSlider();
			this.enableSticky();
		});

		this.$watch('product', () => {
			this.buildVariantSelections();
			this.getSetData();
			this.klaviyoTracking();
		});

		this.$watch('activeSlide', () => {
			mainSlider.slideTo(this.activeSlide - 1, 200);
		});

		this.$watch('variant_selections', () => {
			this.setDefaultPreselectedValues();
			this.gtmTracking();
		});

		this.$watch('show_error', () => {
			if (this.show_error === true) {
				document.body.classList.add('no-scroll');
			} else {
				document.body.classList.remove('no-scroll');
			}
		});
	},
});
